export default class extends HTMLElement {
  connectedCallback () {
    this.addEventListener('click', () => {
      document.body.append(this.template.content.cloneNode(true))
    })
  }

  get template () {
    return document.getElementById(this.dataset.templateId)
  }
}
